import { Injectable } from "@angular/core";
import { EMPTY, Observable } from "rxjs";
import { Category } from "../interfaces/category.interface";
import { RequestUtilsService } from "./requestUtils";
import { GetHttpHeadersSimple } from "./serviceUtils";
import { mapCategories, mapCategory } from "./requestMapperUtils";

@Injectable({
    providedIn: "root"
})
export class CategoryService {
    constructor(private requestUtils: RequestUtilsService) {}

    getCategories(businessArea: string): Observable<Category[]> {
        if (!businessArea) return EMPTY;
        const url = `svk_casecategories?$select=svk_casecategoryid,svk_name&$filter=(statecode eq 0 and _svk_businessarea_value eq '${businessArea}' and svk_publishonweb eq true)&$orderby=svk_name asc`;
        return this.requestUtils.createGetRequest<Category[]>(url, mapCategories, GetHttpHeadersSimple);
    }

    getCategory(categoryId: string): Observable<Category> {
        if (!categoryId) return EMPTY;
        const url = `svk_casecategories(${categoryId})?$select=svk_casecategoryid,svk_name&$filter=(statecode eq 0 and svk_publishonweb eq true)&$orderby=svk_name asc`;
        return this.requestUtils.createGetRequest<Category>(url, mapCategory, GetHttpHeadersSimple);
    }
}
